import { ButtonBase, Stack, SxProps, Theme, useTheme } from '@mui/material';
import { cleanCents } from '../../../utils/global/helper';

const getButtonSx = (theme: Theme, isSelected: boolean) =>
  ({
    flex: 1,
    borderRadius: '5px',
    p: 1,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    backgroundColor: isSelected ? theme.palette.primary.main : 'transparent',
    color: isSelected ? '#ffffff' : 'text.primary',
  }) as SxProps<Theme>;

interface Props {
  availableBalanceCents: number;
  payoutAmountCents: number;
  onSelect: (amount: number) => void;
}

function PercentButtons({
  availableBalanceCents,
  payoutAmountCents,
  onSelect,
}: Props) {
  const theme = useTheme();

  const twentyFivePercent = cleanCents(availableBalanceCents * 0.25);
  const fiftyPercent = cleanCents(availableBalanceCents * 0.5);
  const hasBalance = availableBalanceCents > 0;

  return (
    <Stack
      width="100%"
      boxSizing="border-box"
      justifyContent="space-between"
      direction="row"
      bgcolor={theme.palette.lightGrey.main}
      p={1}
      borderRadius="5px"
      gap={1}>
      <ButtonBase
        sx={getButtonSx(
          theme,
          hasBalance && payoutAmountCents === twentyFivePercent,
        )}
        onClick={() => onSelect(twentyFivePercent)}>
        25%
      </ButtonBase>
      <ButtonBase
        sx={getButtonSx(
          theme,
          hasBalance && payoutAmountCents === fiftyPercent,
        )}
        onClick={() => onSelect(fiftyPercent)}>
        50%
      </ButtonBase>
      <ButtonBase
        sx={getButtonSx(
          theme,
          hasBalance && payoutAmountCents === availableBalanceCents,
        )}
        onClick={() => onSelect(availableBalanceCents)}>
        MAX
      </ButtonBase>
    </Stack>
  );
}

export default PercentButtons;
